import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useRef } from "react";

const menuList = [
    { title: "चुनाव 2026", slug: "/elections/assembly-chunav" },
    { title: "पश्चिम बंगाल चुनाव", slug: "/elections/assembly-chunav/west-bengal" },
    { title: "असम चुनाव", slug: "/elections/assembly-chunav/assam" },
    { title: "केरल चुनाव", slug: "/elections/assembly-chunav/kerala" },
    { title: "तमिलनाडु चुनाव", slug: "/elections/assembly-chunav/tamil-nadu" },
    { title: "पुडुचेरी चुनाव", slug: "/elections/assembly-chunav/puducherry" },
];

const ElectionMainTab = () => {
    const router = useRouter();
    const currentPath = (router?.asPath || "").split("?")[0];
    const masterconfig = useContext(MasterConfigContext);
    const bgbanner = masterconfig?.["assembly_widgets_2026"]?.desktopBannerUrl
    const showHomeCategoryBanner = masterconfig?.["assembly_widgets_2026"]?.["showHomeCategoryBanner"];
    // console.log("electionKeys", electionKeys);
    const activeRef = useRef(null);
    const showSponsor = masterconfig?.["assembly_widgets_2026"]?.showSponsor;
    const sponsers = [
        {
            url: "https://imptrack.intoday.in/click_tracker.php?domain=NEWSTAK&clientCode=501709&k=https%3A%2F%2Ftinyurl.com%2Fhkucwfzb",
            image: "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/tecno.png",
        },
        {
            url: "https://imptrack.intoday.in/click_tracker.php?domain=NEWSTAK&clientCode=501682&k=https%3A%2F%2Fbit.ly%2F3KoYy6U",
            image: "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/agiluslogo.jpg",
        },
        {
            url: "https://imptrack.intoday.in/click_tracker.php?domain=NEWSTAK&clientCode=501698",
            image: "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/90x55_1.png",
        },
        // {
        //     url: "https://imptrack.intoday.in/click_tracker.php?domain=NEWSTAK&clientCode=501692",
        //     image: "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/87x55.png",
        // },
    ];


    useEffect(() => {
        if (activeRef.current) {
            activeRef.current.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
            });
        }
    }, [currentPath]);

    return (
         <div className="w-full bg-gray-100">
            <div
                className="w-full md:h-38 bg-cover bg-center bg-no-repeat px-4 md:px-10 py-6"
                style={{
                    backgroundImage: `url('${bgbanner}')`,
                }}
            >
                <div className="flex flex-col gap-4">


                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">


                        <h3 className="text-xl w-full md:text-3xl font-bold text-black flex items-center gap-2">
                            विधानसभा चुनाव <span className="text-red-600">2026</span>
                        </h3>

                      
                        {showSponsor && (
                            <div className="w-full flex justify-center md:justify-end">

                                <div className="flex flex-col items-center gap-2 w-fit">

                               
                                    <div className="flex items-center text-xs text-black w-full">
                                        <div className="flex-grow h-[2px] bg-black"></div>
                                        <span className="px-2 whitespace-nowrap">POWERED BY</span>
                                        <div className="flex-grow h-[2px] bg-black"></div>
                                    </div>

                                  
                                    <div className="flex flex-wrap items-center justify-center gap-3">
                                        {sponsers.map((sponsor, index) => (
                                            <a
                                                key={index}
                                                href={sponsor.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="flex-shrink-0"
                                            >
                                                <img
                                                    src={sponsor.image}
                                                    alt="sponsor"
                                                    className="h-10 sm:h-10 md:h-10 lg:h-12 w-auto object-contain"
                                                />
                                            </a>
                                        ))}
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>


                    <div className="flex gap-3 overflow-x-auto scrollbar-hide">

                        {menuList.map((item, index) => {
                            const isActive =
                                item.slug === "/elections/assembly-chunav"
                                    ? currentPath === item.slug
                                    : currentPath.includes(item.slug);

                            return (
                                <a
                                    key={index}
                                    href={item.slug}
                                    target="_blank"
                                    ref={isActive ? activeRef : null}
                                    className={`${isActive
                                        ? "bg-primary text-white border-2 border-primary"
                                        : "border-2 bg-white text-gray-600 hover:text-primary"
                                        }  px-3 py-1 rounded-xl whitespace-nowrap flex items-center justify-center flex-shrink-0`}
                                >
                                    {item.title}
                                </a>
                            );
                        })}
                    </div>

                </div>
            </div>
        </div>  
    );
};

export default ElectionMainTab;